import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";

import "../../assets/style/tablesG.css";
import { ComprasListaItem } from "./ComprasListaItem";

export const TableList = ({ filters, setFilters, list = [], cantidad = 0 }) => {
  const [page, setPage] = useState(1);

  const handleChange = (event, value) => {
    setPage(value);
    const newFilters = {
      ...filters,
      page: value,
    };
    setFilters(newFilters);
  };

  return (
    <>
      {/* <h3>Compras</h3> */}
      <div className="p-table">
        <div className="flex justify-between items-center">
          <div className="ms-2 text-gray-500">{cantidad} gastos encontrados</div>
          <div>
            <Pagination
              count={10}
              page={page}
              size="small"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="table-responsive">
          <table className="table p-table-global">
            <thead className="p-thead-global">
              <tr className="text-center p-tr-titles-global">
                <th scope="col" className="text-end">
                  Número
                </th>
                <th scope="col">Estado</th>
                <th scope="col">Fecha Gasto</th>
                {/*  <th scope="col">Fecha Vcto.</th> */}
                <th scope="col" className="text-start">
                  Proveedor
                </th>
                <th scope="col" className="text-start">
                  Descripción del gasto
                </th>
                <th scope="col" className="text-start">
                  Origen
                </th>
                {/* <th scope="col" className="text-end">
                  Monto Base
                </th>
                <th scope="col" className="text-end">
                  Impuesto
                </th> */}
                <th scope="col" className="text-end">
                  Total
                </th>
                <th scope="col" className="text-end">
                  Pagado
                </th>
                <th scope="col" className="text-end">
                  Por Pagar
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length > 0 &&
                list?.map((item) => (
                  <ComprasListaItem key={item.id} {...item} />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
